import React, { useEffect, useRef } from 'react';
import PaymentPlansCard from './PaymentPlansCard';
import observer from '../utils/observer';

const PaymentPlans = () => {
  const refValue = useRef(null);

  useEffect(() => {
    observer(refValue, 'section-hidden');
  }, [refValue]);

  return (
    <div className="payment-plan-container section-hidden" ref={refValue}>
      <div className="payment-plan-header">
        Kick-start your wellness journey with your preferred plan.
      </div>
      <div className="payment-plan-cards">
        <PaymentPlansCard
          title={`Starter`}
          subTitle={`This plan is tailored to beginners`}
          price={`4,500`}
          isMiddle={false}
          isLast={false}
          isEvery={true}
        />
        <PaymentPlansCard
          title={`Intermediate`}
          subTitle={`Save 1,500`}
          price={`12,000`}
          isMiddle={true}
          isLast={false}
          isEvery={false}
          monthAmount={3}
        />
        <PaymentPlansCard
          title={`Premium Wellness`}
          subTitle={`Save 2,000`}
          price={`25,000`}
          isMiddle={false}
          isLast={true}
          isEvery={false}
          monthAmount={6}
        />
      </div>
    </div>
  );
};

export default PaymentPlans;
